import React from 'react';
import { Route } from 'react-router';

export default (
  <Route path="/LoginPass"
    getComponent={(location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('./index.js'));
      });
    }}
  />
);



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Tube/screens/LoginPass/router.js
 **/